module.exports = __webpack_public_path__ + "img/伯才稻田.1769a7df.png";